<template>
  <div class="entry-list">
    <van-tabs v-model="role" @change="onRefresh">
      <van-tab title="领队" :name="1"></van-tab>
      <van-tab title="队员" :name="0"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="teams" v-if="teams.length > 0">
        <div class="team" v-for="(item, index) in teams" :key="index">
          <div class="top">
            <div class="left">
              <div class="status-team-name">
                <span class="status _0" v-if="item.isSubmit === 0">未提交</span>
                <span class="status _0" v-else-if="item.auditStatus === 0 || item.auditStatus === 1">待确认</span>
                <span class="status _1" v-else-if="item.auditStatus === 3">已锁定</span>
                <span class="status _2" v-else-if="item.auditStatus === 2">已确认</span>
                <span class="status _3" v-else-if="item.auditStatus === -1">已退回</span>
                <span class="team-name" v-if="item.role === 1">{{ item.name }}</span>
                <span class="team-name" v-else>{{ item.trueName }}</span>
              </div>
              <div class="row" v-if="item.role === 1">
                <span class="group">{{ item.chineseName }}</span>
              </div>
              <div class="row" v-else>
                <div class="group">{{ item.name }}({{ getPartByIndex(item.chineseName, 1) }})</div>
                <div class="group">{{ getPartByIndex(item.chineseName, 0) }}</div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="bottom">
            <div class="row">
              <van-button style="width: 120px; height: 28px; margin-left: 12px" type="info" round @click="goMatch(item)">
                <span style="font-size: 12px">前往赛事总览</span>
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无报名" />
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Dialog, PullRefresh, Empty } from 'vant'
Vue.use(Tabs).use(Tab).use(Dialog).use(PullRefresh).use(Empty)
import { getPassport } from "@/libs/passport"
import { getAccountTeamListByUser } from '@/api/match'
export default {
  data() {
    return {
      accountId: '',
      teams: [],
      isLoading: false,
      role: 1
    }
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    getPassport().then(res => {
      if (res) {
        this.getAccountTeamListByUser()
      }
    })
  },
  methods: {
    onRefresh() {
      this.getAccountTeamListByUser()
    },
    getPartByIndex(s, i) {
      if (!s) return ''
      const arr = s.split('_')
      if (arr.length > i) return arr[i]
      return ''
    },
    getAccountTeamListByUser() {
      const params = {
        role: this.role,
        accountId: this.accountId
      }
      getAccountTeamListByUser(params).then(res => {
        if (res) {
          const { data } = res
          this.teams = data.list
          this.isLoading = false
          const user = data.user || {}
          if (!user.mobile) {
            Dialog.alert({
              title: '您还没有关联手机号',
              message: '关联手机号后，可查看电子参赛证，获取看更多赛事信息',
            }).then(() => {
              this.$router.push('/entry-page/correlate-mobile')
            })
          }
        }
      })
    },
    goMatch(obj) {
      console.log(obj);
      this.$router.push('/union-match/match-overall?unionMatchId=' + obj.unionMatchId)
    }
  }
}
</script>

<style lang="scss">
.entry-list {
  .teams {
    padding: 16px 16px 20px 16px;

    .team {
      padding: 16px 12px 12px 12px;
      margin-bottom: 12px;
      background-color: #F8F8F8;
      border-radius: 4px;

      .top {
        display: flex;
        justify-content: space-between;

        .left {
          .status-team-name {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            .status {
              color: #FFFFFF;
              border-radius: 2px;
              display: inline-block;
              height: 20px;
              width: 48px;
              line-height: 20px;
              font-size: 12px;
              text-align: center;
            }

            ._0 {
              background-color: #0ABB58;
            }

            ._1 {
              background-color: #333333;
            }

            ._2 {
              background-color: #0ABB58;
            }

            ._3 {
              background-color: #F95252;
            }

            .team-name {
              font-size: 16px;
              height: 20px;
              color: #333333;
              margin-left: 4px;
            }
          }

          .row {
            padding: 5px 0;

            .group {
              font-size: 14px;
              color: #333333;
            }
          }
        }

        .right {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .line {
        margin: 4px 0 12px 0;
        height: 1px;
        background-color: #F3F3F3;
      }

      .bottom {
        .row {
          display: flex;
          justify-content: right;
        }
      }
    }
  }
}
</style>
